import React, { useCallback, useEffect } from "react";
import { usePanAndZoom } from "./hook/usePanAndZoom";
import eventBus from "../eventBus";

const PanAndZoomWrapper = ({
  containerRef,
  isPreview,
  minZoom = 0.5,
  maxZoom = 2.5,
  mainWrapperStyle = {},
  movableContainerStyle = {},
  zoom,
  isScrollDisabled = false,
  children,
}) => {
  const { onMouseDown, onWheel, translateX, translateY, scale } = usePanAndZoom(
    {
      containerRef,
      minZoom,
      maxZoom,
      initialY: isPreview ? 60 : 100,
      isScrollDisabled,
    }
  );

  const calculate = useCallback(
    (minZoomOnCenterView = 0.2) => {
      if (!containerRef?.current) return;

      const scrollContainer = containerRef.current.parentElement;
      const chart = containerRef.current;

      const containerWidth = scrollContainer.offsetWidth;
      const chartWidth = chart.scrollWidth * scale;

      if (chartWidth > containerWidth) {
        const neededSpace = (containerWidth * 100) / chartWidth;
        let fittingScale = (Math.floor(neededSpace / 5) * 5) / 100;

        if (fittingScale < minZoomOnCenterView) {
          fittingScale = minZoomOnCenterView;
        }

        eventBus.dispatch("caelor-pan-zoom-center-view", {
          newZoomLevel: fittingScale,
          newHorizontalPosition: -((chartWidth - containerWidth) / 2),
        });
      } else if (scale > 1.0) {
        eventBus.dispatch("caelor-pan-zoom-center-view", {
          newZoomLevel: scale,
          newHorizontalPosition: 0,
        });
      } else {
        eventBus.dispatch("caelor-pan-zoom-center-view", {
          newZoomLevel: 1,
          newHorizontalPosition: 0,
        });
      }
    },
    [containerRef, scale]
  );

  useEffect(() => {
    eventBus.on("caelor-handle-center-view", (data) => {
      calculate(data?.minZoomOnCenterView);
    });

    return () => {
      eventBus.remove("caelor-handle-center-view");
    };
  }, [calculate]);

  return (
    <div
      style={{ ...mainWrapperStyle }}
      ref={containerRef}
      onMouseDown={onMouseDown}
      onWheel={onWheel}
    >
      <div
        id="translate-wrapper-inner"
        style={{
          minWidth: "fit-content",
          transform: `translate(${translateX}px, ${translateY}px) scale(${zoom})`,
          ...movableContainerStyle,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default PanAndZoomWrapper;
